import { Directive, Input } from '@angular/core';

@Directive()
export abstract class NoDataBaseComponent {
  @Input() image?: string;
  @Input() text? = 'general_no_data_l';
  @Input() className: string;
}
